import TubeIcon from '@material-ui/icons/SwitchVideo'
import List from './List'

export default {
  list: List,
  icon: TubeIcon,
}
